import Select from 'react-select'
import { useState } from 'react'


export default function DropDown(props) {
  const [ddStyle, setDDStyle] = useState('dropdown')

  return (
    <div className={props.classOne ? props.classOne : 'mb-1 row field'}>
            {props.title && <label className={props.classTwo ? props.classTwo : 'col-sm-4 col-form-label fw-bold'} >{props.title}</label>}
            <div className={props.classThree ? props.classThree : 'col-sm-7'}>
              {!props.required ?
                <Select
                id={props.name}
                key={props.name}
                name={props.name}
                options={props.options}
                onChange={props.onChange}
                className={props.classFour ? props.classFour : ddStyle}
                onFocus={() => setDDStyle('bottom-dd')}
                onBlur={() => setDDStyle('dropdown')}
                maxMenuHeight={props.maxHeight}
                placeholder={props.placeholder}
                value={props.value}
                aria-label={props.title}
                /> :
                <Select
                id={props.name}
                key={props.name}
                name={props.name}
                options={props.options}
                onChange={props.onChange}
                className={props.classFour ? props.classFour : ddStyle}
                onFocus={() => setDDStyle('bottom-dd')}
                onBlur={() => setDDStyle('dropdown')}
                maxMenuHeight={props.maxHeight}
                placeholder={props.placeholder}
                required
                value={props.value}
                aria-label={props.title}
                />
              }
                {props.errorMsg && <p className="error">{props.errorMsg}</p>}
            </div>
        </div>
  )
}
